import React, { PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, Icon, Typography } from 'foundations-library/components'

const jss = (theme) => {
    const { colors } = theme['foundations-library']
    return {
        infoSection: {
            borderRadius: 6,
            padding: '13px 15px',
            background: colors.neutral[50],
            display: 'flex',
            gap: 10,
            '& ul': {
                marginBottom: 0
            }
        },
        icon: {
            flexShrink: 0
        }
    }
}

const useStyles = makeStyles(jss)

interface PropsInterface {
    link?: string,
    linkText?: string,
    'data-testid'?: string
}

/**
 *
 */
const InfoSection = ({
    children,
    link,
    linkText = 'Learn more',
    'data-testid': dataTestId = 'info-section'
}: PropsWithChildren<PropsInterface>): JSX.Element => {
    const styles = useStyles()

    const onClick = () => {
        if (link) {
            window.open(link, '_blank', 'noopener,noreferrer')
        }
    }

    return <div className={styles.infoSection} data-testid={dataTestId}>
        <Icon name='infotip-stylized' color='neutral-900' className={styles.icon} data-testid={`${dataTestId}-icon`}/>
        <div>
            <Typography variant='body3' color='neutral-700' data-testid={`${dataTestId}-text`}>
                {children}
            </Typography>
            {link ? <Button variant='text' color='primary' onClick={onClick} data-testid={`${dataTestId}-button`}>{linkText}</Button> : null}
        </div>
    </div>
}

export default InfoSection
